import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { PiCity } from 'react-icons/pi';
import { FaMapLocationDot } from 'react-icons/fa6';
import { IoLocationSharp } from 'react-icons/io5';
import { Link, useNavigate } from 'react-router-dom';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import DOMPurify from 'dompurify';
import { Pagination } from 'react-bootstrap';
import { MdLeaderboard } from 'react-icons/md';
interface Visit {
  visitedAt: string;
  city: string;
  country: string;
  ipAddress: string;
  latitude: number;
  longitude: number;
  timezone: string;
}
interface Property {
  id: string;
  name: string;
  location: string;
  description: string;
  shortUrl: string;
  latitude: number;
  longitude: number;
  size: string;
  price: string;
  owner: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  propertyUrl: string;
  qrCode: string;
  createdAt: string;
  updatedAt: string;
  visitCount: number;
  photos: Array<{
    url: string;
    public_id: string;
    _id: string;
  }>;
  allVisits: Visit[];
}

const ImageGallery: React.FC<{
  property: Property | null;
  allVisits: Visit[];
  id?: string;
}> = ({ property, allVisits, id }) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const role = useSelector((state: RootState) => state.auth.user?.role);

  const BackToProperties = () => {
    navigate('/dashboard/properties');
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentVisits = allVisits.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(allVisits.length / itemsPerPage);
  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <Container fluid className="p-4">
        {role !== 'admin' && (
          <div>
            <Row className="g-5 mb-5 mb-lg-4">
              <Col xs={12} xl={12}>
                <div className="">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="page-title-heading">
                      <h2 className="fw-bold">Our Latest Property Listings</h2>
                      <p className="text-muted">
                        Explore stunning real estate options with modern
                        amenities.
                      </p>
                    </div>
                    <div className="mt-md-0 ms-3 ms-md-0">
                      {role === 'user' && (
                        <Button
                          className="btn btn-primary px-5 w-md-auto ms-4"
                          style={{ marginRight: '18px' }}
                          onClick={BackToProperties}
                        >
                          Back
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <h2 className="fw-bold mt-4 mb-4">{property?.name}</h2>
            <Row>
              <Col lg={6} md={12}>
                {property?.photos && property.photos.length > 0 ? (
                  <Card className="mb-3">
                    <Card.Img
                      variant="top"
                      src={property.photos[0].url}
                      className="img-fluid rounded"
                      alt="Property Image"
                    />
                  </Card>
                ) : (
                  <div className="text-center ">No image available</div>
                )}
              </Col>
              {property?.photos && property.photos.length > 1 && (
                <Col lg={6} md={12}>
                  <Row>
                    {property.photos.slice(1, 4).map((photo, index) => (
                      <Col xs={6} key={index}>
                        <Card className="mb-3">
                          <Card.Img
                            variant="top"
                            src={photo.url}
                            className="img-fluid rounded"
                            style={{
                              height: '360px',
                              objectFit: 'cover'
                            }}
                            alt={`Property Image ${index + 1}`}
                          />
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Col>
              )}
            </Row>
            <Row>
              <Col>{property?.location}</Col>
            </Row>

          
            <Row>
              <Col className="mt-5" lg={6} md={6}>
                <h1 className="fw-bold">${property?.price}</h1>
                <a href="#" className="text-muted text-decoration-none">
                  Total Price
                </a>
              </Col>

              <Col className="mt-5" lg={6} md={6}>
                <Row className="mt-3">
                  <Col xs={6} className="text-start">
                    <h3 className="fw-bold">{property?.longitude}</h3>
                    <span className="text-muted">longitude</span>
                    <div className="mt-3">
                      <h3 className="fw-bold">{property?.latitude}</h3>
                      <span className="text-muted">latitude</span>
                    </div>
                  </Col>
                  <Col xs={6} className="text-center">
                    <h3 className="fw-bold">{property?.size}</h3>
                    <span className="text-muted">[Sq Ft]</span>
                    <div className="mt-3">
                      <h3 className="fw-bold">{property?.visitCount}</h3>
                      {role === 'user' ? (
                        <Link
                          to="/lead-details"
                          state={{
                            visit: allVisits?.[0],
                            propertyId: property?.id || id
                          }}
                          className="text-primary"
                        >
                          Leads
                        </Link>
                      ) : (
                        <span className="text-muted">Leads</span>
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col className="mt-5" lg={6} md={6}>
                <p
                  className="fw-bold"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(property?.description ?? '')
                  }}
                ></p>
              </Col>
            </Row>
          </div>
        )}
        {role === 'admin' && allVisits && allVisits.length > 0 && (
          <Row className="mt-5">
            <Col>
              <Card>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="fw-bold mb-0">Leads Details</h3>
                    <Button
                      className="btn btn-primary px-5 w-md-auto ms-4"
                      style={{ marginRight: '18px' }}
                      onClick={BackToProperties}
                    >
                      Back
                    </Button>
                  </div>

                  {currentVisits.length === 0 ? (
                    <div className="text-center text-muted mt-4">
                      <h5>No data found</h5>
                    </div>
                  ) : (
                    currentVisits.map((visit, index) => (
                      <div
                        key={index}
                        className="mb-4 mt-4 border rounded p-3 shadow-sm bg-white"
                      >
                        <Row className="align-items-center">
                          <Col
                            xs={12}
                            sm={2}
                            className="text-center mb-3 mb-sm-0"
                          >
                            <MdLeaderboard /> Lead {index + 1} <br />
                          </Col>

                          <Col xs={12} sm={7}>
                            <div>
                              <PiCity /> IP Address: {visit.ipAddress}
                            </div>
                            <div>
                              <IoLocationSharp /> Location: {visit.city}
                            </div>
                            <div>
                              <FaMapLocationDot /> Latitude: {visit.latitude},{' '}
                              <FaMapLocationDot /> Longitude: {visit.longitude}
                            </div>
                          </Col>

                          <Col
                            xs={12}
                            sm={3}
                            className="text-sm-end mt-3 mt-sm-0"
                          >
                            <div className="text-muted mt-1">
                              <i className="bi bi-calendar-event me-1" />
                              {new Date(visit.visitedAt).toLocaleString(
                                'en-US',
                                {
                                  year: 'numeric',
                                  month: 'short',
                                  day: 'numeric',
                                  hour: 'numeric',
                                  minute: '2-digit',
                                  hour12: true
                                }
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    ))
                  )}

                  {totalPages > 1 && (
                    <div className="d-flex justify-content-end mt-4">
                      <Pagination>
                        <Pagination.First
                          onClick={() => handlePageChange(1)}
                          disabled={currentPage === 1}
                        />
                        <Pagination.Prev
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        />

                        {Array.from({ length: totalPages }, (_, i) => (
                          <Pagination.Item
                            key={i + 1}
                            active={i + 1 === currentPage}
                            onClick={() => handlePageChange(i + 1)}
                          >
                            {i + 1}
                          </Pagination.Item>
                        ))}

                        <Pagination.Next
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        />
                        <Pagination.Last
                          onClick={() => handlePageChange(totalPages)}
                          disabled={currentPage === totalPages}
                        />
                      </Pagination>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
};

export default ImageGallery;
